import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import twinFetchPost from '../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../utils/reducers/reduxDispatch'
import { useLocation, useNavigate } from 'react-router'
import { getBasePath } from '../../../../../../utils/globals/link'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'

type ModalNewVersionQuoteProps = ModalEditComponentProps & ModalNewVersionQuoteLogicProps &  {}

const ModalNewVersionQuote: React.FC<ModalNewVersionQuoteProps> = ({ setOpened, onSubmit, allRowData, ...logic }) => {
    const { t } = useTwinTranslation()
    const { createNewVersion, loading } = useModalNewVersionQuoteLogic({...logic})

    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={createNewVersion} loading={loading} translations={{
            title: t('sureNewVersionQuote', '¿Seguro que quieres crear una nueva versión de este presupuesto?'),
            subtitle: t('youCouldReturnToAnyVersion', 'Una vez creada, podrás volver a ver cualquier versión'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

interface ModalNewVersionQuoteLogicProps {
    url: string
    OrderId: number
    onSubmit?: () => void
}

const useModalNewVersionQuoteLogic = ({ url, OrderId, onSubmit }: ModalNewVersionQuoteLogicProps) => {
    const {startLoading, endLoading, loading} = useIsLoading()
    const location = useLocation()
    const path = getBasePath(location.pathname, 'single')
    const navigate = useNavigate()
    const createNewVersion = useCallback(async () => {
        startLoading()
        const response = await twinFetchPost(url, { id: OrderId })
        const responseJSON = await response.json()
        if (response.status === 200) {
            navigate(path + '/' + responseJSON.id)
            onSubmit?.()
        } else {
            changeErrorMessage(responseJSON.errors[0].msg)
            endLoading()
        }
    }, [url, OrderId, onSubmit, navigate, path, startLoading, endLoading])
    return { createNewVersion, loading }
}


export default ModalNewVersionQuote